/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskIndicatorTypeShallow } from './RiskIndicatorTypeShallow';
import {
  RiskIndicatorTypeShallowFromJSON,
  RiskIndicatorTypeShallowFromJSONTyped,
  RiskIndicatorTypeShallowToJSON,
} from './RiskIndicatorTypeShallow';

/**
 *
 * @export
 * @interface RiskMetricSummary
 */
export interface RiskMetricSummary {
  /**
   *
   * @type {number}
   * @memberof RiskMetricSummary
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof RiskMetricSummary
   */
  name: string;
  /**
   *
   * @type {RiskIndicatorTypeShallow}
   * @memberof RiskMetricSummary
   */
  readonly indicator: RiskIndicatorTypeShallow;
  /**
   *
   * @type {string}
   * @memberof RiskMetricSummary
   */
  infoboxDescription?: string;
}

/**
 * Check if a given object implements the RiskMetricSummary interface.
 */
export function instanceOfRiskMetricSummary(value: object): value is RiskMetricSummary {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('indicator' in value) || value['indicator'] === undefined) return false;
  return true;
}

export function RiskMetricSummaryFromJSON(json: any): RiskMetricSummary {
  return RiskMetricSummaryFromJSONTyped(json, false);
}

export function RiskMetricSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskMetricSummary {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    indicator: RiskIndicatorTypeShallowFromJSON(json['indicator']),
    infoboxDescription: json['infobox_description'] == null ? undefined : json['infobox_description'],
  };
}

export function RiskMetricSummaryToJSON(value?: Omit<RiskMetricSummary, 'id' | 'indicator'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    infobox_description: value['infoboxDescription'],
  };
}
